import React, { FC } from 'react';
import { Helmet } from 'react-helmet';

type Props = {
  url: string;
};

export const HeadRobotSeo: FC<Props> = ({ url }) => (
  <Helmet>
    {/* Indexation case: indexation authorized */}
    <meta name="robots" content="index, follow" />
    <link href={url} rel="canonical" />
  </Helmet>
);
